// extracted by mini-css-extract-plugin
export default {"uploadFile":"UploadFile_uploadFile__V-HmP","fileArea":"UploadFile_fileArea__kom1n","send":"UploadFile_send__wNDsa"};